/**
 * Get proxied URL for user profile pictures
 * @param {string} originalUrl - Original profile picture URL
 * @returns {string|null} Proxied URL or null
 */
export const getProxiedUrl = (originalUrl) => {
  if (!originalUrl) return null;
  return `${
    process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080'
  }/api/v1/profile/avatar?url=${encodeURIComponent(originalUrl)}`;
};

/**
 * Extract OAuth provider IDs from oauth2Providers array
 * @param {Array} oauth2Providers - Array of OAuth provider objects
 * @returns {Array<string>} Array of provider IDs
 */
export const getOAuthProviders = (oauth2Providers) => {
  if (!oauth2Providers || !Array.isArray(oauth2Providers)) return [];
  return oauth2Providers.map(
    (provider) => provider.providerId || provider.provider_id
  );
};
